<template>
    <import from="./general-tab-attribute/general-tab-attribute"></import>
    <import from="./general-tab-attr-type/general-tab-attr-type"></import>
    <import from="./general-tab-class/general-tab-class"></import>
    <import from="./general-tab-usr-grp/general-tab-usr-grp"></import>
    <import from="./general-tab-relationclass/general-tab-relationclass"></import>
    <import from="./general-tab-user/general-tab-user"></import>
    <import from="./general-tab-procedure/general-tab-procedure"></import>
    <import from="./general-tab-file/general-tab-file"></import>
    <section class="mt-3">
        <!--  UUID -->
        <div class="form-floating mb-3">
            <input class="form-control" id="uuidInput" maxlength="256" placeholder="UUID" type="text"
                value.bind="selectedObjectService.selectedObject.uuid" readonly>
            <label for="uuidInput">UUID</label>
        </div>
        <!-- Name Input -->
        <div class="form-floating mb-3">
            <input class="form-control" id="nameInput" maxlength="256" placeholder="Name" type="text"
                value.bind="selectedObjectService.selectedObject.name">
            <label for="nameInput">Name</label>
        </div>

        <!-- Description Input -->
        <div class="form-floating mb-3">
            <input class="form-control" id="descriptionInput" maxlength="256" placeholder="Description" type="text"
                value.bind="selectedObjectService.selectedObject.description">
            <label for="descriptionInput">Description</label>
        </div>

        <!-- Geometry Input -->
        <div class="form-floating mb-3">
            <textarea class="form-control" id="geometryInput" placeholder="Geometry" rows="3" style="height: 100px"
                value.bind="selectedObjectService.selectedObject.geometry"></textarea>
            <label for="geometryInput">Geometry</label>
        </div>

        <!-- 2D Coordinates -->
        <fieldset class="border p-2">
            <legend class="float-none w-auto p-2 col-form-label">Coordinates 2D</legend>
            <div class="row">
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="twodCoordXInput">X</span>
                        <input aria-describedby="twodCoordXInput" aria-label="X" class="form-control"
                            placeholder="2d x coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.coordinates_2d.x">
                    </div>
                </div>
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="twodCoordYInput">Y</span>
                        <input aria-describedby="twodCoordYInput" aria-label="Y" class="form-control"
                            placeholder="2d y coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.coordinates_2d.y">
                    </div>
                </div>
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="twodCoordZInput">Z</span>
                        <input aria-describedby="twodCoordZInput" aria-label="Z" class="form-control"
                            placeholder="2d z coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.coordinates_2d.z">
                    </div>
                </div>
            </div>
        </fieldset>

        <!-- Absolute 3D Coordinates -->
        <fieldset class="border p-2">
            <legend class="float-none w-auto p-2 col-form-label">Absolute coordinates 3D</legend>
            <div class="row">
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="abs2dCoordXInput">X</span>
                        <input aria-describedby="abs2dCoordXInput" aria-label="X" class="form-control"
                            placeholder="Absolute x coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.absolute_coordinate_3d.x">
                    </div>
                </div>
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="abs2dCoordYInput">Y</span>
                        <input aria-describedby="abs2dCoordYInput" aria-label="Y" class="form-control"
                            placeholder="Absolute y coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.absolute_coordinate_3d.y">
                    </div>
                </div>
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="abs2dCoordZInput">Z</span>
                        <input aria-describedby="abs2dCoordZInput" aria-label="Z" class="form-control"
                            placeholder="Absolute z coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.absolute_coordinate_3d.z">
                    </div>
                </div>
            </div>
        </fieldset>

        <!-- Relative 3D Coordinates -->
        <fieldset class="border p-2">
            <legend class="float-none w-auto p-2 col-form-label">Relative Coordinates 3D</legend>
            <div class="row">
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="rel2dCoordXInput">X</span>
                        <input aria-describedby="rel2dCoordXInput" aria-label="X" class="form-control"
                            placeholder="Relative x coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.relative_coordinate_3d.x">
                    </div>
                </div>
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="rel2dCoordYInput">Y</span>
                        <input aria-describedby="rel2dCoordYInput" aria-label="Y" class="form-control"
                            placeholder="Relative y coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.relative_coordinate_3d.y">
                    </div>
                </div>
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="rel2dCoordZInput">Z</span>
                        <input aria-describedby="rel2dCoordZInput" aria-label="Z" class="form-control"
                            placeholder="Relative z coordinate" type="number"
                            value.bind="selectedObjectService.selectedObject.relative_coordinate_3d.z">
                    </div>
                </div>
            </div>
        </fieldset>


        <!-- Rotation -->
        <fieldset class="border p-2">
            <legend class="float-none w-auto p-2 col-form-label">Rotation</legend>
            <div class="row">
                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="rotationXInput">X</span>
                        <input aria-describedby="rotationXInput" aria-label="X" class="form-control"
                            placeholder="X rotation" type="number"
                            value.bind="selectedObjectService.selectedObject.rotation.x">
                    </div>
                </div>

                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="rotationYInput">Y</span>
                        <input aria-describedby="rotationYInput" aria-label="Y" class="form-control"
                            placeholder="Y rotation" type="number"
                            value.bind="selectedObjectService.selectedObject.rotation.y">
                    </div>
                </div>

                <div class="col">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="rotationZInput">Z</span>
                        <input aria-describedby="rotationZInput" aria-label="Z" class="form-control"
                            placeholder="Z rotation" type="number"
                            value.bind="selectedObjectService.selectedObject.rotation.z">
                    </div>
                </div>
            </div>
        </fieldset>


        <!-- Attribute type -->
        <general-tab-attribute if.bind="selectedObjectService.type === 'Attribute'"></general-tab-attribute>

        <!-- Attribute -->
        <general-tab-attr-type if.bind="selectedObjectService.type === 'AttributeType'"></general-tab-attr-type>

        <!-- Class -->
        <general-tab-class if.bind="selectedObjectService.type === 'Class'"></general-tab-class>

        <!-- User group -->
        <general-tab-usr-grp if.bind="selectedObjectService.type === 'UserGroup'"></general-tab-usr-grp>

        <!-- RelationClass -->
        <general-tab-relationclass if.bind="selectedObjectService.type === 'RelationClass'"></general-tab-relationclass>

        <!-- User -->
        <general-tab-user if.bind="selectedObjectService.type === 'User'"></general-tab-user>

        <!-- Procedure -->
        <general-tab-procedure if.bind="selectedObjectService.type === 'Procedure'"></general-tab-procedure>

        <!-- Files -->
        <general-tab-file if.bind="selectedObjectService.type === 'File'"></general-tab-file>
    </section>
</template>